import React, { Component } from "react";
import commonUtil from "../../../../../../utils/commonUtil";
import ContractPage from "../../../EventData/ContractPage";

const channel = commonUtil.getChannel().toUpperCase();

class ContractEM extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const params = {
      eventID: this.props.eventID,
    };

    const { userEventDetails } = this.props;

    const eventType = userEventDetails?.eventDetailsInfo?.eventType || '';
    const eventDate = userEventDetails?.eventDetailsInfo?.eventDate || '';

    return (
      <React.Fragment>
        <ContractPage
          {...this.props}
          params={params}
          eventType={eventType}
          eventDate={eventDate || ''}
          isGiftListContract={true}
          onBackClick={this.props.onBackClick}
        />
      </React.Fragment>
    );
  }
}

export default ContractEM;
